import { render, staticRenderFns } from "./IconNotifications.vue?vue&type=template&id=6caf5546&scoped=true"
import script from "./IconNotifications.vue?vue&type=script&lang=js"
export * from "./IconNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf5546",
  null
  
)

export default component.exports